import { useEffect, useState, useRef, useCallback } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";

import { usePageMetadata } from '../../hooks/usePageMetadata';
import styles from "./Safety.module.css"
import safety_logo_nb from "../../assets/images/safety_logo_nb.svg";
import mylo_home_banner from "../../assets/images/mylo_home_banner_red.svg";
import mylo_home_banner_short from "../../assets/images/mylo_home_banner_short.svg";

import mylo_safe_white_red from "../../assets/images/mylo_safe_white_red.svg";
import team_banner from "../../assets/images/team_banner.jpg";
import technology from "../../assets/images/technology.png";
import smoke_alarm from "../../assets/images/smoke_alarm.jpg";
import cloud1 from "../../assets/images/cloud1_black.svg";
import cloud2 from "../../assets/images/cloud2_black.svg";
import cloud3 from "../../assets/images/cloud3_black.svg";
import car1 from "../../assets/images/car1_black.svg";
import car2 from "../../assets/images/car2_black.svg";

import Footer from "../Footer"
import Topbar from "../Topbar"


const Banner = () => {
	return (
		<div className={styles.banner_container}>
			<div className={styles.banner_inner_container}>
				<div className={styles.banner_inner}>
					<img src={mylo_safe_white_red}/>

					<div className={styles.banner_heading}>
						<h1 className={`xl3 forma bold ${styles.optimised}`}>Protect your property & your tenants with MYLO safety compliance.</h1>
						<h1 className={`xxxxxxl3 forma bold ${styles.non_optimised}`}>Protect your property & your tenants with MYLO safety compliance.</h1>

						<a className={styles.banner_button} href={"tel:+136956"}>
							<p className={`xl1 inter medium`}>Book an Inspection</p>
							<i className="fa-solid fa-calendar-days xl2"></i>
						</a>
					</div>
				</div>

				<div className={styles.transition_container} style={{ bottom: '-80px' }}>
					<div className={styles.transition_effect_1} style={{ bottom: '50px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cf2930" }}/>
					<div className={styles.transition_effect_2} style={{ bottom: '20px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cf2930" }}/>
					<div className={styles.transition_effect_3} style={{ bottom: '-10px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cf2930" }}/>
				</div>
			</div>
		</div>
	)
}

const ServiceMessage = () => {
	return (
		<div className={styles.cmessage_container}>
			<p className={`xxxxl3 forma bold ${styles.cmessage_banner}`}>End-to-end safety checks that take the stress out of compliance—trusted by property managers and homeowners to protect what matters most.</p>
			<p className={`m2 inter light`}>At MYLO, we specialise in delivering comprehensive safety compliance services for residential properties across Victoria. Our safety checks cover smoke alarms, gas appliances, electrical systems and minimum standards checks, ensuring full alignment with current legislative requirements. Every inspection is carried out by fully qualified, multi-skilled technicians who take the time to do the job properly—identifying potential hazards before they become costly problems.<br/><br/>We understand that compliance can feel complex, which is why we make it simple. You’ll receive a clear, concise report outlining the property’s status, including photographic evidence and practical recommendations. Whether you’re a property manager overseeing multiple rentals or a homeowner ensuring your family’s safety, our team provides the same level of care, consistency, and professionalism.<br/><br/>MYLO will help you stay ahead of regulatory obligations while reducing risk and avoiding last-minute surprises. Our client portal adds another layer of efficiency, offering real-time access to reports, certificates, quotes and service history—all in one place.<br/><br/>With MYLO, you’re not just meeting safety standards—you’re exceeding them, with a partner who understands the importance of trust, clarity, and accountability in every home.</p>
		</div>
	)
}

const BannerImage = () => {
	return (
		<div className={styles.bannerimg_wrapper}>
			<div className={styles.bannerimg_container}/>
			<p className={`xxxxxl3 forma bold ${styles.bannerimg_banner}`}>Your trusted partner in property safety,<br/>servicing homes and rentals across Victoria</p>
		</div>
	)
}

const HouseTransition = () => {
	return (
		<div className={styles.house_transition_wrapper}>
			<div className={styles.house_transition_circle}>
				<img src={safety_logo_nb}/>
			</div>
		</div>
	)
}

const Services = ({ scrollToId }) => {
	return (
		<div className={styles.services_container}>
			<div className={styles.inner_services}>
				<div className={styles.services_catheaders}>
					<p className={`xxxxl3 forma bold`}><span>Safety</span> Services</p>
					<i className={`fa-thin fa-arrow-right xxxl3 ${styles.non_optimised}`}></i>

					<i className={`fa-solid fa-shield-check xxxxl3 ${styles.safety_icon} ${styles.non_optimised}`}></i>
				</div>

				<p className={`m2 inter light ${styles.services_catsubheader}`}>At MYLO, we provide thorough safety compliance services for residential properties across Victoria, helping landlords and homeowners meet all legal requirements with ease. Our fully licensed technicians carry out comprehensive inspections of smoke alarms, electrical systems, gas appliances, and rental minimum standards. All checks are in accordance with ESV and VBA guidelines, so we stay up to date with the latest regulations to ensure every inspection meets current standards. After each visit, you’ll receive a clear report with photos, compliance outcomes, and any recommended actions. With MYLO’s client portal and efficient service model, staying compliant is simple, reliable, and stress-free—so you can avoid risk, reduce liability, and focus on what matters</p>

				<div className={styles.service_inner}>
					<div className={styles.services_overview_split}>
						<div className={styles.services_overview_item}>
							<p className={`xl2 inter bold ${styles.services_overview_active}`}>Smoke Alarms</p>
							<p className={`xl2 inter bold`}>Rental Minimum Standards Checks</p>
							<p className={`xl2 inter bold`}>Smoke alarm testing and servicing</p>
							<p className={`xl2 inter bold`}>Free battery replacements</p>
							<p className={`xl2 inter bold`}>Switchboard Testing</p>
							<p className={`xl2 inter bold`}>Appliance testing</p>
							<p className={`xl2 inter bold`}>Earth Continuity</p>
							<p className={`xl2 inter bold`}>Power Points</p>
							<p className={`xl2 inter bold`}>Gas Leaks</p>
							<p className={`xl2 inter bold`}>Carbon Monoxide</p>
							<p className={`xl2 inter bold`}>Negative Pressure</p>
							<p className={`xl2 inter bold`}>LPG Tank Checks</p>
						</div>
						
						<div className={styles.services_overview_img}>
							<img src={smoke_alarm}/>
						</div>
					</div>

					<div className={styles.service_bottom_btns}>
						<div className={styles.service_bottom_btns_circle}><i className="fa-thin fa-arrow-left xl3"></i></div>
						<div className={styles.service_bottom_btns_circle}><i className="fa-thin fa-arrow-right xl3"></i></div>
					</div>

					<div className={styles.services_subcatheaders}>
						<p className={`xxl3 forma bold`}><span>Safety</span> Solutions</p>
					</div>

					<div className={styles.services_solutions_container}>
						<ul>
							<li><p className={`m2 inter light`}>Smoke Alarm Replacement</p></li>
							<li><p className={`m2 inter light`}>Smoke Alarm Batteries</p></li>
							<li><p className={`m2 inter light`}>Testing & Maintenance</p></li>
							<li><p className={`m2 inter light`}>Compliance Services</p></li>
							<li><p className={`m2 inter light`}>Hardwiring</p></li>
							<li><p className={`m2 inter light`}>Service Report</p></li>
							<li><p className={`m2 inter light`}>Digitially Record</p></li>
						</ul>
					</div>

					<button className={`${styles.service_bottom_btns_btn}`} onClick={() => scrollToId("packages")}>
						<p className={`m2 inter medium`}>View our Packages</p>
						<i className="fa-solid fa-box-open m3"></i>
					</button>
				</div>
			</div>
		</div>
	)
}

const HowItWorks = () => {
	const [collapsed, setCollapsed] = useState([0])
	const data = {
		"Choose your Package": {
			text: "Use our online service calculator to select the right safety package for your property",
			button: null
		},
		"Sign Up": {
			text: "Complete our digital service agreement form, providing key property details so we can begin the process of making your home safe and compliant",
			button: null
		},
		"Confirmation": {
			text: "We will confirm all details with either yourself directly or your property manager - depending on your preference",
			button: null
		}
	}

	const handleCollapse = (key) => {
		if (collapsed.includes(key)) {
			setCollapsed((prev) => ([...prev].filter(k => k !== key)))
		} else {
			setCollapsed((prev) => ([...prev, key]))
		}
	}

	return (
		<div className={styles.howitworks_container}>
			<div className={styles.transition_container} style={{ top: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ top: '50px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#cf2930" }}/>
				<div className={styles.transition_effect_2} style={{ top: '20px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#cf2930" }}/>
				<div className={styles.transition_effect_3} style={{ top: '-10px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#cf2930" }}/>
			</div>

			<div className={styles.howitworks_inner_container}>
				<div className={styles.howitworks_heading}>
					<p className={`xxxxl3 forma bold`}>How it Works</p>
					<i className={`fa-thin fa-arrow-right xxxl3 ${styles.non_optimised}`}></i>

					<i className={`fa-solid fa-gear xxxxl3 ${styles.howitworks_icon}`}></i>
				</div>

				<p className={`xxl3 forma medium ${styles.howitworks_subheading_main}`}>Booking a service with MYLO is very easy.</p>
				<p className={`m2 inter light ${styles.howitworks_subheading}`}>Simply follow the steps below and before you know it, we'll have a specialised MYLO consultant, tradesperson or assessor booked in to begin modifying your home to suit your needs.</p>

				<div className={styles.steps_container}>
					{Object.keys(data).map((key, index) => {
						const isCollapsed = collapsed.includes(key)
						const text = data[key].text
						const btn = data[key].btn

						return (
							<button className={`${styles.step_container} ${isCollapsed && styles.step_container_full}`} onClick={() => handleCollapse(key)}>
								<div className={`${styles.step_heading} ${styles.non_optimised}`}>
									<div className={styles.step_ticker}><p className={`l2 inter medium`}>Step {index+1}</p></div>
									<p className={`xl1 inter medium`}>{key}</p>

									<i className={`fa-thin fa-${isCollapsed ? "minus" : "plus"} xxxxl3`}></i>
								</div>

								<div className={`${styles.step_heading} ${styles.optimised}`}>
									<div className={styles.step_ticker}><p className={`l2 inter medium`}>{index+1}</p></div>
									<p className={`xl1 inter medium`}>{key}</p>

									<i className={`fa-thin fa-${isCollapsed ? "minus" : "plus"} xxxxl3`}></i>
								</div>

								{isCollapsed &&
									<div className={styles.step_content}>
										<p className={`m2 inter light`}>{text}</p>

										{btn &&
											<button className={styles.step_content_button}>
												<p className={`m2 inter medium`}>Create a MYLO Account</p>
												<i className="fa-thin fa-arrow-right m3"></i>
											</button>
										}
									</div>
								}
							</button>
						)
					})}
				</div>

				<div className={styles.howitworks_help}>
					<p className={`xxl3 forma medium ${styles.howitworks_subheading_main}`}>Got Questions...? No Problems.</p>
					<p className={`m2 inter light ${styles.howitworks_help_text}`}>Call 13MYLO 24/7 or connect via our helpdesk to talk to one of our specialised consultants<br/>about how we can support you in creating a home environment to suit all your needs.</p>

					<a className={styles.howitworks_help_button} href={"tel:+136956"}>
						<p className={`m2 inter medium`}>Call 13MYLO</p>
						<i className="fa-solid fa-phone m3"></i>
					</a>
				</div>
			</div>
		</div>
	)
}


const HouseBanner = () => {
  	const refs = {
    	car1: useRef(null),
    	car2: useRef(null),
    	cloud1: useRef(null),
    	cloud2: useRef(null),
    	cloud3: useRef(null),

    	car1opt: useRef(null),
    	cloud1opt: useRef(null)
  	};

  	const config = [
    	{ key: "car1", speed: 0.3, dir: 1 },
    	{ key: "car2", speed: 0.3, dir: -1 },
    	{ key: "cloud1", speed: 0.2, dir: 1 },
    	{ key: "cloud2", speed: 0.2, dir: -1 },
    	{ key: "cloud3", speed: 0.2, dir: -1 },

    	{ key: "car1opt", speed: 0.025, dir: 1 },
    	{ key: "cloud1opt", speed: 0.025, dir: -1 }
  	];

  	const targetXs = useRef(config.map(() => 0));
  	const currentXs = useRef(config.map(() => 0));

  	useEffect(() => {
    	const handleScroll = () => {
      		const y = window.scrollY;
      		config.forEach((c, i) => {
        		targetXs.current[i] = y * c.speed;
      		});
    	};

    	window.addEventListener("scroll", handleScroll, { passive: true });

    	let rafId;
    	const animate = () => {
      		config.forEach((c, i) => {
        		const el = refs[c.key].current;
        		if (!el) return;
        		currentXs.current[i] += (targetXs.current[i] - currentXs.current[i]) * 0.1;
        		el.style.transform = `translateX(${currentXs.current[i] * c.dir}px)`;
      		});

      		rafId = requestAnimationFrame(animate);
    	};

    	rafId = requestAnimationFrame(animate);

    	return () => {
      		window.removeEventListener("scroll", handleScroll);
      		cancelAnimationFrame(rafId);
    	};
  	}, []);


	return (
		<div className={styles.house_banner_container}>
			<img src={mylo_home_banner} className={`${styles.car_banner} ${styles.non_optimised}`}/>
			<img src={car1} className={`${styles.car1} ${styles.non_optimised}`} ref={refs.car1}/>
			<img src={car2} className={`${styles.car2} ${styles.non_optimised}`} ref={refs.car2}/>
			<img src={cloud1} className={`${styles.cloud1} ${styles.non_optimised}`} ref={refs.cloud1}/>
			<img src={cloud2} className={`${styles.cloud2} ${styles.non_optimised}`} ref={refs.cloud2}/>
			<img src={cloud3} className={`${styles.cloud3} ${styles.non_optimised}`} ref={refs.cloud3}/>

			<img src={mylo_home_banner_short} className={`${styles.car_banner} ${styles.optimised}`}/>
			<img src={car1} className={`${styles.car1opt} ${styles.optimised}`} ref={refs.car1opt}/>
			<img src={cloud1} className={`${styles.cloud1opt} ${styles.optimised}`} ref={refs.cloud1opt}/>
		</div>
	)
}

const Packages = () => {
	const [activeTerms, setActiveTerms] = useState("Annually")
	const pricing = {
		"Weekly": {
			"MYLO Silver": 7,
			"MYLO Gold": 9
		},
		"Annually": {
			"MYLO Silver": 290,
			"MYLO Gold": 399
		}
	}

	return (
		<div className={styles.packages_container} id="packages">
			<div className={styles.transition_container} style={{ top: '0', height: '90px', backgroundColor: "black" }}>
				<div className={styles.transition_effect_1} style={{ top: '0', background: "#cf2930", height: '30px' }}/>
				<div className={styles.transition_effect_2} style={{ top: '30px', background: "#cf2930", height: '30px' }}/>
				<div className={styles.transition_effect_3} style={{ bottom: '0', background: "#cf2930", height: '30px' }}/>
			</div>


			<div className={styles.packages_inner_container}>
				<HouseTransition/>

				<div className={styles.packages_heading}>
					<i className={`fa-solid fa-box-open xxxxl3 ${styles.optimised} ${styles.howitworks_icon}`}></i>
					<p className={`xxxxl3 forma bold`}>Safety Packages</p>
					<i className={`fa-thin fa-arrow-right xxxl3 ${styles.non_optimised}`}></i>

					<i className={`fa-solid fa-box-open xxxxl3 ${styles.howitworks_icon} ${styles.non_optimised}`}></i>
				</div>

				<p className={`xxl3 forma medium ${styles.howitworks_subheading_main}`}>Our customised services ensure that participants have safe, accessible,<br/>and well-maintained homes suited to their individual needs.</p>
				<p className={`m2 inter light ${styles.howitworks_subheading}`}>Every property is different, which is why MYLO offers a range of package options tailored to your needs. Whether you’re after a one-off compliance check, a monthly or annual subscription, or a customised structure to suit your portfolio, we’re here to help you protect your property with ease and confidence.<br/><br/>All subscription models come with a two-year minimum commitment, ensuring long-term value and consistent compliance coverage.<br/><br/>How are we able to keep the pricing low and consistent? Our unique subscription model is unlike anything else on the market. By strategically structuring inspections across a two-year cycle, we’re able to offer year-round service at a consistently low cost—without compromising on quality or coverage.<br/><br/>To ensure your property remains safe and fully compliant, we follow a structured inspection process:<br/><br/>Year 1: A full compliance check covering Gas, Electrical, and Smoke Alarms.<br/>Year 2 onwards:</p>
				<ul className={styles.howitworks_ul}>
					<li><p className={`m2 inter light`}>Annual Smoke Alarm Inspections (as required by law)</p></li>
					<li><p className={`m2 inter light`}>Gas and Electrical Inspections alternating each year—one year a licensed gas fitter will conduct the gas safety check, and the next year an electrician will conduct the electrical inspection.</p></li>
					<li><p className={`m2 inter light`}>We cover the additional inspection costs in the first cycle to establish this rhythm, enabling a more efficient, affordable system moving forward.</p></li>
				</ul>

				<HouseBanner/>

				<div className={styles.package_list_container}>
					<div className={styles.package_list_header}>
						<p className={`xl3 forma medium ${styles.package_list_heading}`}>Some of our convenient Safety Packages are here</p>

						<a className={styles.package_list_button} href={"tel:+136956"}>
							<p className={`m2 inter medium`}>Call us to discuss which<br/>package is right for you</p>
							<i className="fa-solid fa-phone l3"></i>
						</a>
					</div>

					<div className={styles.package_controls}>
						<button className={`${styles.package_control} ${activeTerms === "Weekly" && styles.package_control_active}`} onClick={() => setActiveTerms("Weekly")}>
							<p className={`m2 inter medium`}>Weekly</p>
						</button>

						<button className={`${styles.package_control} ${activeTerms === "Annually" && styles.package_control_active}`} onClick={() => setActiveTerms("Annually")}>
							<p className={`m2 inter medium`}>Annually</p>
						</button>
					</div>

					<div className={styles.package_list}>
						<div className={styles.package_item}>
							<div className={styles.package_item_heading}>
								<div className={`${styles.package_item_heading_r1} ${styles.non_optimised}`}>
									<p className={`xxl1 forma bold ${styles.package_list_heading}`}>${pricing[activeTerms]["MYLO Silver"]} {activeTerms === "Weekly" ? "per week" : "annually"}</p>	
								</div>
								<div className={`${styles.package_item_heading_r2} ${styles.non_optimised}`}/>
								<div className={`${styles.package_item_heading_r3} ${styles.non_optimised}`}/>

								<i className="fa-solid fa-award xl1"></i>
								<div>
									<p className={`l3 forma bold ${styles.package_list_heading}`}>MYLO Silver</p>
									<p className={`l3 forma bold ${styles.package_list_heading} ${styles.optimised}`}>${pricing[activeTerms]["MYLO Silver"]} {activeTerms === "Weekly" ? "per week" : "annually"}</p>
								</div>
							</div>

							<div className={styles.services_include_container}>
								<p className={`l2 forma medium ${styles.package_list_heading}`}>Services Include:</p>

								<ul>
									<li><p className={`m3 inter light`}>Full Electrical Compliance Check</p></li>
									<li><p className={`m3 inter light`}>Full Gas Compliance Check - (all gas appliances inclusive)</p></li>
									<li><p className={`m3 inter light`}>Annual Smoke Alarms Check</p></li>
									<li><p className={`m3 inter light`}>Priority Emergency Response</p></li>
									<li><p className={`m3 inter light`}>Unlimited Smoke Alarms Callout</p></li>
									<li><p className={`m3 inter light`}>Advanced Management Portal</p></li>
									<li><p className={`m3 inter light`}>Comprehensive Compliance Reports</p></li>
									<li><p className={`m3 inter light`}>MYLO Multi-Qualified Technicians</p></li>
									<li><p className={`m3 inter light`}>Flexible Payment Structure</p></li>
								</ul>
							</div>
						</div>

						<div className={styles.package_item}>
							<div className={styles.package_item_heading}>
								<div className={`${styles.package_item_heading_r1} ${styles.non_optimised}`}>
									<p className={`xxl1 forma bold ${styles.package_list_heading}`}>${pricing[activeTerms]["MYLO Gold"]} {activeTerms === "Weekly" ? "per week" : "annually"}</p>
								</div>
								<div className={`${styles.package_item_heading_r2} ${styles.non_optimised}`}/>
								<div className={`${styles.package_item_heading_r3} ${styles.non_optimised}`}/>

								<i className="fa-solid fa-award xl1"></i>
								<div>
									<p className={`l3 forma bold ${styles.package_list_heading}`}>MYLO Gold</p>
									<p className={`l3 forma bold ${styles.package_list_heading} ${styles.optimised}`}>${pricing[activeTerms]["MYLO Gold"]} {activeTerms === "Weekly" ? "per week" : "annually"}</p>
								</div>
							</div>

							<div className={styles.services_include_container}>
								<p className={`l2 forma medium ${styles.package_list_heading}`}>Services Include:</p>

								<ul>
									<li><p className={`m3 inter light`}>Full Electrical Compliance Check</p></li>
									<li><p className={`m3 inter light`}>Full Gas Compliance Check - (all gas appliances inclusive)</p></li>
									<li><p className={`m3 inter light`}>Annual Smoke Alarms Check</p></li>
									<li><p className={`m3 inter light`}>Minimum Standards Report</p></li>
									<li><p className={`m3 inter light`}>Unlimited Smoke Alarms Callout</p></li>
									<li><p className={`m3 inter light`}>Unlimited Handyman Callout</p></li>
									<li><p className={`m3 inter light`}>Unlimited Electrical Callout</p></li>
									<li><p className={`m3 inter light`}>Unlimited Plumber Callout</p></li>
									<li><p className={`m3 inter light`}>Free Emergency Locksmith Callouts</p></li>
									<li><p className={`m3 inter light`}>Advanced Management Portal</p></li>
									<li><p className={`m3 inter light`}>MYLO Multi-Qualified Technicians</p></li>
									<li><p className={`m3 inter light`}>Flexible Payment Structure</p></li>
									<li><p className={`m3 inter light`}>Priority Emergency Response</p></li>
									<li><p className={`m3 inter light`}>Comprehensive Compliance Reports</p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}



const Calculator = () => {
	return (
		<div className={styles.calculator_container}>
			<div className={styles.inner_calculator}>
				<div className={styles.calculator_catheaders}>
					<p className={`xxxxl3 forma bold`}><span>Safety</span> Calculator</p>
					<i className={`fa-thin fa-arrow-right xxxl3 ${styles.non_optimised}`}></i>

					<i className={`fa-solid fa-calculator xxxxl3 ${styles.safety_icon} ${styles.non_optimised}`}></i>
				</div>

				<p className={`xxl3 forma medium ${styles.calculator_subheading_main}`}>Use our easy to use pricing calculator to see how much it<br/>would cost to ensure your home stays safe all year round.</p>
				<p className={`m2 inter light ${styles.calculator_catsubheader}`}>Take the hassle out of pricing your products with this free service pricing calculator. Our trusted pricing formula will help you find a fair price for your services, so you can sit back & relax knowing all your home safety services are taken care of by reliable, trusted technicians.</p>
				
				<div className={styles.calculator_inner}>
					<div className={styles.calculator_box_main}>
						<p className={`l1 forma medium`}>Payment Terms:</p>
						<div className={styles.calculator_button_container}>
							<button className={`${styles.calculator_button} ${styles.calculator_button_active}`}>
								<p className={`m3 inter medium`}>Yearly</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Monthly</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>One-Off</p>
							</button>
						</div>

						<p className={`l1 forma medium ${styles.calculator_btnheading}`}>Subscription:</p>
						<div className={styles.calculator_button_container}>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Gold</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Silver</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>No Package</p>
							</button>
						</div>

						<p className={`l1 forma medium ${styles.calculator_btnheading}`}>Services:</p>
						<div className={styles.calculator_button_container}>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Gas</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Smoke</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Electrical</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Rental Minimum Standards</p>
							</button>
						</div>

						<div className={styles.heading_bottom}>
							<p className={`m2 inter light`}>Every property is different, which is why MYLO offers a range of package options tailored to your needs. Whether you’re after a one-off compliance check, a monthly or annual subscription, or a customised structure to suit your portfolio, we’re here to help you protect your property with ease and confidence.</p>
							<p className={`m3 inter bold ${styles.red_heading}`}>For more info, call us on 13 MYLO (13 69 56) today</p>
						</div>
					</div>

					<div className={styles.calculator_box_services}>
						<p className={`xl1 forma medium ${styles.calculator_priceheading}`}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut semper metus sed nunc tincidunt ac cumsan. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut semper metus sed nunc tincidunt ac cumsan.</p>

						<div className={styles.calculator_circle}><i className={`fa-thin fa-arrow-down xl1`}></i></div>

						<div className={styles.calculator_price_banner}>
							<p className={`xl1 inter bold`}>$340 +GST</p>
						</div>
					</div>
					
					<div className={styles.calculator_box_price}>
						<p className={`xl1 forma medium ${styles.calculator_priceheading}`}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut semper metus sed nunc tincidunt ac cumsan. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut semper metus sed nunc tincidunt ac cumsan.</p>

						<div className={styles.calculator_circle}><i className={`fa-thin fa-arrow-down xl1`}></i></div>

						<div className={styles.calculator_price_banner}>
							<p className={`xl1 inter bold`}>$340 +GST</p>
						</div>
					</div>

				</div>
			</div>
		</div>
	)
}



const FrequentlyAskedQuestions = () => {
	const [collapsed, setCollapsed] = useState(0)
	const questions = [
		{
			question: "Will you service a Smoke Alarm if it has an issue in between inspections?",
			answer: "Of course! We guarantee a full service and testing of your alarms. If they start beeping before our next visit, we will attend to this free of charge under warranty."
		},
		{
			question: "What happens if I cancel my subscription after the first year?",
			answer: "All of our subscriptions have a two year minimum commitment. This means that should you opt out of the contract before the termination date, the balance of your subscription will be owing."
		},
		{
			question: "Can I sign up for my properties in bulk?",
			answer: "Absolutely. We offer many options of signing up properties, including system integrations or bulk uploads."
		},
		{
			question: "Are there discounts for owners with multiple properties?",
			answer: "Yes, we offer tiered discounts for owners with multiple properties. The more properties you sign up, the greater the savings. Our pricing structure is designed to reward volume and provide long-term value for portfolio owners. We’re happy to tailor a package that suits your portfolio size and compliance needs."
		},
		{
			question: "What are the regulations for smoke alarms?",
			answer: "All the up to date information regarding smoke alarm compliance can be found here: https://www.consumer.vic.gov.au/housing/renting/repairs-alterations-safety-and-pets/keeping-the-property-safe/smoke-alarms-and-fire-safety"
		},
		{
			question: "Do you supply quotes for any report findings?",
			answer: "If our inspection identifies any issues—whether it’s an urgent repair, a safety concern, or a general recommendation—we’ll provide an obligation-free quote, as long as it falls within our scope of services. Our goal is to make follow-up work as simple and transparent as possible, so you can take action with confidence."
		},
		{
			question: "What if my property has upcoming due dates that do not line up?",
			answer: "We will tailor our services to suit your needs. Get in touch with us to find out more"
		},
		{
			question: "What are the costs for smoke alarm replacements?",
			answer: "There is a charge for replacing smoke alarms. Battery-operated alarms are $39 + GST, while 240v hardwired alarms are quoted on a case-by-case basis—typically around $140 + GST. Hardwired replacements require installation by an A-grade licensed electrician, and we never cut corners when it comes to safety or compliance. Our pricing reflects our commitment to using qualified professionals and meeting all regulatory standards, so you can have full confidence in the quality of the work."
		}
	]

	return (
		<div className={styles.faq_container}>
			<div className={styles.faq_inner_container}>
				<p className={`xxxxl3 forma bold ${styles.faq_heading} ${styles.non_optimised}`}>MYLO Safety FAQ's</p>
				<p className={`xxxxl3 forma bold ${styles.faq_heading} ${styles.optimised}`}>FAQ's</p>

				<div className={styles.faq_main_container}>
					{questions.map((q, index) => (
						<button className={styles.faq_button} onClick={() => setCollapsed(index)}>
							<p className={`l3 forma medium`}>{q.question}</p>

							{collapsed === index &&
								<div className={styles.faq_content}>
									<p className={`m2 inter light`}>{q.answer}</p>
								</div>
							}

							<i className={`fa-thin fa-${collapsed === index ? "minus" : "plus"} xxxxl3`}></i>
						</button>
					))}
				</div>
			</div>

			<HouseTransition/>

			<div className={styles.transition_container} style={{ bottom: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ bottom: '50px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cacaca" }}/>
				<div className={styles.transition_effect_2} style={{ bottom: '20px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cacaca" }}/>
				<div className={styles.transition_effect_3} style={{ bottom: '-10px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cacaca" }}/>
			</div>
		</div>
	)
}







const Safety = () => {
	usePageMetadata({
		title: "MYLO | Safety",
		description: "Keep your home compliant and protected with MYLO Safety. We deliver expert inspections for smoke alarms, gas alarms, electrical systems, and more—so you can rest easy."
	});

  	const containerRef = useRef(null);

  	useEffect(() => {
    	const container = containerRef.current;
    	if (!container) return;

    	const children = Array.from(container.children).filter(el => el.id !== 'packages');
    	const observer = new IntersectionObserver((entries, obs) => {
      		entries.forEach(entry => {
        		if (entry.isIntersecting) {
          			entry.target.classList.add(styles.isVisible);
          			obs.unobserve(entry.target);
        		}
      		});
    	}, { threshold: 0.1 });

    	children.forEach(el => {
      		el.classList.add(styles.fadeInSection);
      		observer.observe(el);
    	});

    	return () => observer.disconnect();
  }, []);


	const scrollToId = (id) => {
  		const el = document.getElementById(id);
  		if (!el) return;

  		const headerOffset = 0;
  		const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
  		const offsetPosition = elementPosition - headerOffset;

  		window.scrollTo({
    		top: offsetPosition,
    		behavior: 'smooth'
  		});
	}


	return (
		<div className={styles.background} ref={containerRef}>
			<Topbar active={"Safety"}/>
			<Banner/>
			<ServiceMessage/>
			<BannerImage/>
			<HouseTransition/>

			<Services scrollToId={scrollToId}/>
			<HowItWorks/>
			<Packages/>
			{/* <Calculator/> */}
			<FrequentlyAskedQuestions/>

			<Footer/>
		</div>
	)
};

export default Safety;